import React from "react";
import { CartReferenceNumber } from "tsi-common-react/src/apps/checkout/CartReferenceNumber";
import { Link } from "tsi-common-react/src/components/Link/index";
import { SVGIcon } from "tsi-common-react/src/components/SVGIcon/index";
import { isoWebPageURL } from "tsi-common-react/src/models/nominals";
import { jt, t } from "ttag";

import { templates } from "@reactivated";

export const Template = (
    props: templates.CheckoutHeaderTemplate,
): React.ReactNode => {
    const secure = (
        <span
            key="secure"
            className="checkout-header__header--bold"
        >{t`secure`}</span>
    );
    const secureCheckout = jt`${secure} checkout`;
    const urlPageLink = isoWebPageURL.wrap(props.root_page_url);
    return (
        <header className="l-full-width">
            <nav className="site-nav checkout-header">
                <div className="site-nav__content checkout-header__content l-capped-width">
                    <Link className="site-nav__logo-link" href={urlPageLink}>
                        {/* TODO(i18n): Translate alt attribute value with t tagged template */}
                        <SVGIcon
                            svgClassName="site-nav__pillows-logo"
                            name="pillowsLogo"
                            alt="TEMPUR-PILLOWS FROM TEMPUR-PEDIC®"
                        />
                    </Link>
                    <Link
                        className="site-nav__logo-link--mobile"
                        href={urlPageLink}
                    >
                        {/* TODO(i18n): Translate alt attribute value with t tagged template */}
                        <SVGIcon
                            svgClassName="site-nav__pillows-logo--mobile"
                            name="pillowsLogo"
                            alt="TEMPUR-PILLOWS FROM TEMPUR-PEDIC®"
                        />
                    </Link>
                    <h1 className="checkout-header__header">
                        {secureCheckout}
                    </h1>

                    <div className="checkout-header__header-cart-ref">
                        <CartReferenceNumber
                            encodedBasketID={props.encoded_basket_id}
                            phoneNumber={props.support_website_phone_number}
                        />
                    </div>
                </div>
            </nav>
        </header>
    );
};
